import { render } from "./UnsubscribeModal.vue?vue&type=template&id=60adba54&scoped=true"
import script from "./UnsubscribeModal.vue?vue&type=script&lang=js"
export * from "./UnsubscribeModal.vue?vue&type=script&lang=js"

import "./UnsubscribeModal.vue?vue&type=style&index=0&id=60adba54&scoped=true&lang=css"

import exportComponent from "/var/www/hutch/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60adba54"]])

export default __exports__